<template>
  <div>
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      :value="value"
      allow-clear
      option-filter-prop="title"
      show-search
      @change="onChange"
      :class="class"
      :virtual="false"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="item.id"
        :title="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onActivated, onMounted, watch } from "vue";
import { ContractSimpleReq } from "@/views/purchase/contract/contract.interface";
import { ContractService } from "@/views/purchase/contract/contract.service";
import { useRoute } from "vue-router";

/**
 * 采购合同选择器
 */
export default defineComponent({
  isGlobal: true,
  name: "PurchaseContractSelect",
  props: {
    value: { type: String, default: undefined },
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    class: { type: String, default: "append-to-body" },
    disabled: { type: Boolean, default: false },

    placeholder: { type: String, default: "请选择" },
    addRightBizType: {
      type: String,
      default: undefined,
    },
    contractStatus: { type: Array, default: () => [] },
  },
  emits: ["update:value", "change", "update:contractInfo","selectChange"],
  setup(props, { emit }) {
    const { data, run, loading } = ContractService.useSimpleListApi();
    const route = useRoute();
    const onChange = async (id='') => {
      emit("update:value", id);
      emit("change", id);
      emit("selectChange",id);
      let tmp = data.value?.records.find((i) => i.id == id);
      // console.log(tmp, id, data.value);
      if (tmp) {
        emit("update:contractInfo", tmp);
      }
    };
    const search = async () => {
      const req = new ContractSimpleReq();
      if (_.isArray(props.contractStatus) && props.contractStatus.length) {
        req.merge({ contractStatus: props.contractStatus.join(",") });
      }
      if(props.addRightBizType){
        req.merge({ addRightBizType: props.addRightBizType });
      }
      if(route['query']['projectId']){ // 优先展示该项目下的数据
        req.merge({ firstDisplayProjectId: route['query']['projectId'] });
      }
      await run(req);
      if (props.externalData.purchaseContractId && props.externalData.purchaseContractName) {
        data.value?.records && (data.value?.records as any).push({ id: props?.externalData?.purchaseContractId, name: props?.externalData?.purchaseContractName });
      }
    };
    watch(
      () => props.value,
      async (id,oldId) => {
        if (id) {
          // console.log(data.value?.records?.length,'-----------------')
          //@ts-ignore
          if (!data.value?.records?.length) {
            await search();
          }
          let tmp = data.value?.records.find((i) => i.id == id);
          // console.log(tmp, id, data.value,'-------==========--------========-------');
          if (tmp) {
            emit("update:contractInfo", tmp);
            emit("change",tmp.id||'');
          }
        }
      }
    );
    

    onMounted(async () => {
      // if(props.value){
        await search();
      // }
    });
    onActivated(async () => {
      // if(props.value){
        await search();
      // }
    });

    return {
      data,
      loading,
      onChange,
    };
  },
});
</script>
